import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from "react-i18next";
import CryptoJS from "crypto-js";

const SECRET_KEY = "mySecretKey123";

export default function ButtonCreateCarePlan({ patientId }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleCreateCarePlan = () => {
    if (patientId) {
      const encryptedId = CryptoJS.AES.encrypt(patientId.toString(), SECRET_KEY).toString();
      const urlSafeId = encodeURIComponent(encryptedId);
     navigate(`/create-care-plan/${urlSafeId}`);
    } else {
      console.error("Error: No patientId provided!");
    }
  };

  return (
    <Button
      variant="contained"
      sx={{
        backgroundColor: "#085394",
        color: "#fff",
        "&:hover": {
          backgroundColor: "#063970",
        },
      }}
      startIcon={<AddIcon />}
      onClick={handleCreateCarePlan}
    >
      {t("CarePlan.createCarePlan")}
    </Button>
  );
}
